import functions from '../functions.js';
import { details } from './details';

$(() => {
    detailsAccommodation.init();
})

const detailsAccommodation = {
    $details: null,
    $form: null,
    form: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: null,
        calcErrorMessages: null,
    },
    defaults: {
        guests: null, 
        dates: null,
        dateFrom: null, 
        dateTo: null, 
        objectGroupId: 1,
        optionals: 'base',
    },
    init() {

        this.$details = $('.page-type-details');
        this.params.objectGroupId = this.$details.attr('data-objectgroupid');
        this.params.chtg = this.$details.attr('data-chtg');

        if(! this.$details[0] || this.params.objectGroupId != 1) {
            return;
        }
        if(+this.$details.attr('data-dynamicpackage') != 0) {
            return;
        }

        this.$form = $('.availability-form');
        this.form = this.$form[0];

        this.params.objectId = this.$details.attr('data-objectid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;
        this.allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));

        const $serviceCode = $('[name="serviceCode"]');
        if($serviceCode.length) {
            this.params.serviceCode = $serviceCode.val();
        }

        this.getParams();
        if(! this.params.dates && this.params.dateFrom && this.params.dateTo) {
            this.params.dates = this.params.dateFrom + ' - ' + this.params.dateTo;
        }
        
        if(this.form) {
            functions.setFormData(this.form, this.params);
        }

        if(this.params.guests) {
            $('[name=guests]').each((index, elem) => {
                $(elem).val(this.params.guests);

                let guests = this.params.guests.split(',');
                let i = 1;
                for (let index = 2; index < guests.length; index++) {
                    if(guests[index]) {
                        $('[name=child-age-'  + i + ']').val(guests[index]);
                    }
                    i++;
                }
            });
        }

        this.getCalculation();

        this.$form.on('submit', e => {
            e.preventDefault();
            let params = functions.getFormData($(e.currentTarget));
            this.params.rateId = null;
            this.params.unitId = null;
            functions.setUrlData(params, true, true);
        });

        $('.arrangement-form').on('change', e => {
            const $target = $(e.currentTarget);
            let params = functions.getFormData($target);
            params.unitId = this.params.unitId = $target.attr('data-unitid');
            params.rateId = this.params.rateId = $target.attr('data-rateid');
            params.objectGroupId = 1;
            params.pricelistId = $target.find('[name="pricelistId"]').val()

            params.guests = params.guests && params.guests.startsWith('0') ? null : params.guests;
            if(params.dates) {
                if(params.dates || params.dates == '') {
                    const aDates = params.dates.split(' - ');
                    params.dateFrom = aDates[0] ? aDates[0] : null;
                    params.dateTo = aDates[1] ? aDates[1] : null;
                }
            }

            this.getCalculation(params);
        });

        $(window).on('hashchange', e => {
            this.getParams();
            this.getCalculation(this.params);
        });

        $(document).on('change', '.block-totals-per-service [type="radio"]', e => {

            const $unit = $(e.currentTarget).closest('.unit');
            const isArrangement = $unit.hasClass('arrangement');
            const $addToCart = $unit.find('.add-to-cart');
            const $btnBooking = $unit.find('.btn-booking');
            const $radioService = $unit.find('[type="radio"]:checked');
            const $totalPerService = $radioService.closest('.total-per-service');

            let total = $totalPerService.find('[data-totalperservice]').attr('data-totalperservice');
            let totalOld = $totalPerService.find('[data-oldtotalperservice]').attr('data-oldtotalperservice');
            let currency = $totalPerService.find('[data-currency]').attr('data-currency');
            let bookingStatus = $totalPerService.find('[data-bookingstatus]').attr('data-bookingstatus');
            let pricelistid = $totalPerService.find('[data-pricelistid]').attr('data-pricelistid');
            let serviceId = $radioService.val();
            let serviceKey = $radioService.attr('data-servicekey');
            let extras = $radioService.attr('data-extra');

            if ($addToCart.length) {
                $addToCart.attr('data-' + serviceKey, serviceId);
                $addToCart.attr('data-unitcarttotal', total);
                $addToCart.attr('data-unitcarttotalold', totalOld);
                $addToCart.attr('data-currencysymbol', currency);
                $addToCart.attr('data-pricelistid', pricelistid);

                $addToCart.attr('data-datefrom', detailsAccommodation.params.dateFrom);
                $addToCart.attr('data-dateto',  detailsAccommodation.params.dateTo);
                $addToCart.attr('data-guests', detailsAccommodation.params.guests);

            } else {
                $btnBooking.attr('data-' + serviceKey, serviceId);
                $btnBooking.attr('data-pricelistid', pricelistid);
                $btnBooking.attr('data-extra', extras);

                $btnBooking.text(bookingStatus === 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));
            }
        });

        $(document).on('click', '.unit .btn-booking:not(.btn-arrangement)', e => {

            e.preventDefault();
            const $btnBooking = $(e.currentTarget);

            let pricelistId = $btnBooking.attr('data-pricelistid') ? $btnBooking.attr('data-pricelistid') : null;
            let serviceCode = $btnBooking.attr('data-servicecode') ? encodeURIComponent($btnBooking.attr('data-servicecode')) : null;
            let serviceId = $btnBooking.attr('data-serviceid') ? $btnBooking.attr('data-serviceid') : null;
            let extras = $btnBooking.attr('data-extra');
            let params = '';

            if (extras) {
                extras = JSON.parse(extras);

                Object.keys(extras).forEach(function(key) {
                    let val = extras[key];
                    if (key === 'optionRefId' || key === 'remoteUnitId') {
                        val = encodeURIComponent(val);
                    }
                    if ( ! (key && val)) return;

                    params += '&'+key+'=' + val;
                });
            }

            location = $btnBooking.attr('data-href').split('?')[0] +
                '?objectGroupId=' + detailsAccommodation.params.objectGroupId +
                '&unitId=' + $btnBooking.attr('data-unitid') +
                '&dateFrom=' + detailsAccommodation.params.dateFrom +
                '&dateTo=' + detailsAccommodation.params.dateTo +
                '&guests=' + detailsAccommodation.params.guests +
                (pricelistId ? '&pricelistId=' + pricelistId : '') +
                (serviceId ? '&serviceId=' + serviceId : '') +
                (serviceCode ? '&serviceCode=' + serviceCode : '') +
                (params ? params : '') +
                '&addAllOptionals=' + 1;

        });
    },
    printDates() {
        $('.unit-departure').addClass('fade');
        setTimeout(() => {
            $('.unit-departure').removeClass('fade');
            $('.date-from').text(functions.formatDate(this.params.dateFrom));
            $('.date-to').text(functions.formatDate(this.params.dateTo));
            $('.overnights').text($('.departure[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']').attr('data-duration'));
        }, 800);

    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? null : this.params.guests;
        if(this.params.dates) {
            this.splitCalendarDates(this.params.dates);
        }
    },
    splitCalendarDates(dates) {
        if(dates || dates == '') {
            const aDates = dates.split(' - ');
            this.params.dateFrom = aDates[0] ? aDates[0] : null;
            this.params.dateTo = aDates[1] ? aDates[1] : null;
        }
    },
    getCalculation(params) {
        const cParams = params ? params : this.params;
        cParams.calcPerService =  ! cParams.rateId ? 1 : 0;
        const calculation = details.getCalculation(cParams);

        $('.block-booking').toggleClass('d-none', true);
        $('.block-error-msg').toggleClass('d-none', true);

        if(calculation) {
            $('.block-no-calc').toggleClass('d-none', true);

            if (this.params.chtg) {
                $(".units-no-result-msg").addClass('d-none');
                $(".units-loader").removeClass('d-none');
                $(".units .unit-placeholder").addClass('d-none');
                $(".units .unit").addClass('d-none');
            }

            this.loader(cParams.unitId ? $('.unit[data-unitid=' + cParams.unitId + ']').find('.unit-spinner') : null);

            calculation
                .done(response => {
                    this.calculationDone(response, cParams);
                }).fail(error => {
                console.log(error);
            });
        }
        else if (this.params.chtg) {
            $(".units-no-result-msg").addClass('d-none');
            $(".units .unit").addClass('d-none');
            $(".units .unit-placeholder").removeClass('d-none');
            return;
        }
        else if( ! cParams.rateId) {
            $('.block-no-calc').toggleClass('d-none', false);

            const optionals = cParams.optionals ? cParams.optionals : this.defaults.optionals;
            let serviceText = '';
            if(optionals && optionals != this.defaults.optionals) {
                const allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
                allowedServices.forEach(item => {
                    if(item.supplementKey == optionals) {
                        serviceText = item.text;
                    }
                });
            }

            $('.unit').each((index, elem) => {
                const $elem = $(elem);
                const prices = $elem.attr('data-prices') ? JSON.parse($elem.attr('data-prices')) : null;
                const pricelistId = cParams.pricelistId ? cParams.pricelistId : $elem.attr('data-pricelistid');
                const item = prices ? (prices[pricelistId][optionals] ? prices[pricelistId][optionals] : prices[pricelistId]) : null;
                const pricelistsService = $elem.attr('data-pricelistsservice') ? JSON.parse($elem.attr('data-pricelistsservice')) : null;

                if(item) {
                    const $unitPriceTotal = $elem.find('.unit-price-total');
                    const $unitPriceOld = $elem.find('.unit-price-old');
                    const $unitPricePaymentKey = $elem.find('.unit-price-payment-key');
                    const $serviceSupplement = $elem.find('.service-supplement');
    
                    $unitPriceTotal.text(item.price);
                    $unitPriceOld.text(item.priceOld != '€ 0' ? item.priceOld : '');
                    $unitPricePaymentKey.text(item.paymentKey);
                    $serviceSupplement.text(pricelistsService[pricelistId] ? pricelistsService[pricelistId] : serviceText);
                }
                
                const order = $elem.attr('data-order');
                $elem.prop('style', 'order: ' + (order ? order : '10000'));

                $elem.find('.no-calculation').removeClass('d-none');
            })
        }


        if(this.params.pricelistId && $('[data-pricelistsservice]').attr('data-pricelistsservice')) {
            const pricelistsService = JSON.parse($('[data-pricelistsservice]').attr('data-pricelistsservice'));
            $('.service-supplement').text(pricelistsService[this.params.pricelistId] ? pricelistsService[this.params.pricelistId] : '')
        }

        if(this.params.serviceCode) {
            const allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
            let serviceText = '';
            allowedServices.forEach(item => {
                if(item.key == this.params.serviceCode) {
                    serviceText = item.text;
                }
            });
            $('.service-supplement').text(serviceText);
        }
    },

    calculationDonePerService(response, params) {
        $('.unit[data-dynamicunitid]').remove();

        if(response.status) {
            const data = response.data || [];

            if (this.params.chtg) {
                $(".units-no-result-msg").addClass('d-none');
                $(".units-loader").addClass('d-none');
            }

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                let $unit = $('.unit[data-unitid=' + unitId + ']');

                if ( ! $unit.length )
                {
                    if (unitId.indexOf('_') === -1) return;

                    const _unitId = unitId.replace(/_\d+$/, "");
                    const $_unitId = $($('.unit[data-unitid=' + _unitId + ']').prop('outerHTML'));

                    $_unitId.attr('data-dynamicunitid', unitId);
                    $(".units").append($_unitId);

                    $unit = $('.unit[data-dynamicunitid=' + unitId + ']');
                }

                let isBookable = false;

                if(unitData.services && details.isBookablePerService(unitData.services)) {
                    isBookable = true;
                    const total = details.getMinPricePerService(unitData.services);
                    detailsAccommodation.preparePriceAndBooking(unitId, $unit, unitData, params);
                    $unit.prop('style', 'order: ' + parseInt(total));
                } else {
                    $unit.prop('style', 'order: 100000;');
                    $unit.find('.block-discount').toggleClass('d-none', true);
                }

                let error = ! isBookable ? details.getCalcErrorMessage(this.params.calcErrorMessages, unitData) : null;

                $unit.find('.block-error-msg').toggleClass('d-none', isBookable);
                $unit.find('.block-error-msg.unit-error-container').text(error);

                $unit.find('.block-totals-per-service').toggleClass('d-none', ! isBookable);
                $unit.find('.block-booking').toggleClass('d-none', ! isBookable);

                if (this.params.chtg) {
                    $unit.toggleClass('d-none', ! isBookable);
                    $unit.find('[data-unitName]').text(unitData.unitName);
                    let totalGuests = +params.guests.split(',')[0] + +params.guests.split(',')[1];
                    $unit.find('.beds-info').text(totalGuests);
                }

            });

            if (this.params.chtg && ! $(".units .unit").not('.unit-placeholder').not('.d-none').length) {
                $(".units-no-result-msg").removeClass('d-none');
            }
        }
    },
    preparePriceAndBooking(unitId, $unit, unitData, params) {

        const $totalPerServiceBlock = $unit.find('.totals-per-service');
        const totalPerServiceHtml = $totalPerServiceBlock.html();

        let discountTitle;
        $totalPerServiceBlock.html('');

        Object.keys(unitData.services).forEach(( serviceId) => {

            const dataPerService = unitData.services[serviceId];

            const unitCalc = dataPerService.calc;
            const currencySymbol = unitCalc.currencySymbol;
            const bookingStatus = dataPerService.booking.status;
            const unitCalcItems = unitCalc.items;
            const total = unitCalc.total.toFixed(2);
            const pricelistid = unitCalc.items[0].pricelistId;

            const $totalPerServiceHtml = $(totalPerServiceHtml);

            let priceOld = details.getCalcTotalOld(unitCalcItems);
            priceOld = +priceOld.toFixed(2);

            let serviceText = '';
            if (dataPerService.customServiceName) {
                serviceText = dataPerService.customServiceName;
            } else {
                detailsAccommodation.allowedServices.forEach((allowedService) => {
                    if (dataPerService.serviceId && +allowedService.id === +dataPerService.serviceId ||
                        dataPerService.serviceCode && allowedService.key === dataPerService.serviceCode){
                        serviceText = allowedService.text;
                    }
                });

                if ( ! serviceText)
                {
                    if (dataPerService.serviceName) {
                        serviceText = dataPerService.serviceName;
                    }
                }
            }

            let totalRounded = functions.formatMoney(total, 0, '', '');
            $totalPerServiceHtml.attr('style', 'order:' + totalRounded);
            $totalPerServiceHtml.addClass('order-' + totalRounded);
            $totalPerServiceHtml.attr('data-order' , totalRounded);

            const $radio = $totalPerServiceHtml.find('[type="radio"]');

            const radioVal = dataPerService.serviceId || dataPerService.serviceCode;
            $radio.val(radioVal);
            $radio.attr('name', 'service-' + unitId);
            $radio.attr('id', 'service-' + unitId + '-' + radioVal);
            $radio.attr('data-servicekey', dataPerService.serviceCode ? 'serviceCode' : 'serviceId');

            let extra = {};
            if (dataPerService.optionRefId) {
                extra.optionRefId = dataPerService.optionRefId;
            }

            if (unitData.unitName) {
                extra.unitName = unitData.unitName;
            }

            if (unitData.remoteUnitId) {
                extra.remoteUnitId = unitData.remoteUnitId;
            }

            $radio.attr('data-extra', JSON.stringify(extra));

            const $label = $totalPerServiceHtml.find('label');
            $label.find('small').text(serviceText);
            $label.attr('for', 'service-' + unitId + '-' + radioVal);

            const $oldTotal = $totalPerServiceHtml.find('[data-oldtotalperservice]');
            $oldTotal.text(priceOld > total ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
            $oldTotal.attr('data-oldtotalperservice', priceOld > total ? priceOld : '');

            const $total = $totalPerServiceHtml.find('[data-totalperservice]');
            $total.text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
            $total.attr('data-totalperservice', total);
            $total.attr('data-currency', currencySymbol);
            $total.attr('data-bookingStatus', bookingStatus);
            $total.attr('data-pricelistid', pricelistid);

            $totalPerServiceBlock.append($totalPerServiceHtml[0].outerHTML);

            if (priceOld > total && ! discountTitle) {

                $unit.find('.block-discount').toggleClass('d-none', false);
                const $fmDiscount = $unit.find('.fm-discount:not(.fm-discount-custom)');
                discountTitle = details.getCalcDiscountTitle(unitCalcItems);

                if($fmDiscount.length) {
                    if (discountTitle) {
                        $unit.find('.unit-price-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').removeClass('d-none');
                    } else {
                        $unit.find('.fm-discount').addClass('d-none');
                        $unit.find('.fm-discount-valid-until').addClass('d-none');
                    }
                }
            }
        });

        let minp = null;
        $totalPerServiceBlock.find("[data-order]").each((index, elem) => {
            let p = +$(elem).attr('data-order');
            if (minp === null || p < minp) {
                minp = p;
            }
        });

        $totalPerServiceBlock.find(".order-" + minp).find('[type="radio"]').click();
        $totalPerServiceBlock.find(".order-" + minp).addClass('border-0');
    },
    calculationDone(response, params) {

        if (params.calcPerService) {
            return this.calculationDonePerService(response, params);
        }

        if(response.status) {

            const data = response.data || [];

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = this.params.rateId ? $('.arrangement-form[data-unitid=' + unitId + '][data-rateid=' + this.params.rateId + ']') : $('.unit[data-unitid=' + unitId + ']');

                if(details.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total;
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);
                    let discountTitle = details.getCalcDiscountTitle(calcItems);

                    if(discountTitle) {
                        $unit.find('.unit-price-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').text(discountTitle ? discountTitle : '');
                    }

                    if(priceOld > total) {
                        $unit.find('.unit-price-old').text(currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ','));
                        $unit.find('.unit-price-old').removeClass('d-none');
                    } else {
                        $unit.find('.unit-price-old').addClass('d-none');
                    }

                    $unit.find('.unit-price-total').removeClass('d-none');
                    $unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));


                    const $btnBooking = this.params.rateId ? $unit.find('.btn-booking[data-rateId=' + this.params.rateId + ']') : $unit.find('.btn-booking[data-unitId=' + unitId + ']');

                    $btnBooking.text(unitData.booking.status == 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));

                    if($btnBooking.attr('data-href')) {
                        $btnBooking.attr('data-href',
                            $btnBooking.attr('data-href').split('?')[0] +
                            '?objectGroupId=' + params.objectGroupId +
                            '&unitId=' + unitId +
                            '&dateFrom=' + params.dateFrom +
                            '&dateTo=' + params.dateTo +
                            '&guests=' + params.guests +
                            (params.pricelistId ? '&pricelistId=' + params.pricelistId : '') +
                            (params.optionals ? '&optionals=' + params.optionals : '') +
                            (params.serviceCode ? '&serviceCode=' + params.serviceCode : '') +
                            '&addAllOptionals=' + 1
                        );
                    }

                    $btnBooking.on('click', e => {
                        e.preventDefault();
                        location = $(e.currentTarget).attr('data-href');
                    });

                    $unit.prop('style', 'order: ' + functions.formatMoney(total, 0, '', ''));

                    if(params.optionals) {
                        const allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
                        let serviceText = '';
                        allowedServices.forEach(item => {
                            if(item.supplementKey == params.optionals) {
                                serviceText = item.text;
                            }
                        });
                        $unit.find('.service-supplement').text(serviceText);
                    }

                    if(params.serviceCode) {
                        const allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
                        let serviceText = '';
                        allowedServices.forEach(item => {
                            if(item.key == params.serviceCode) {
                                serviceText = item.text;
                            }
                        });
                        $('.service-supplement').text(serviceText);
                        $('.service-supplement').removeClass('d-none');
                    }

                    if(params.pricelistId) {
                        const pricelistsService = JSON.parse($('[data-pricelistsservice]').attr('data-pricelistsservice'));
                        $('.service-supplement').text(pricelistsService[params.pricelistId] ? pricelistsService[params.pricelistId] : '')
                    }
                    
                } else {
                    $unit.prop('style', 'order: 10000');
                }

                $unit.find('.unit-price-label').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-price').toggleClass('d-none', ! details.isBookable(unitData));

                $unit.find('.unit-price-discount-title').toggleClass('d-none', ! details.isBookable(unitData));
                $unit.find('.unit-price-payment-key').toggleClass('d-none', details.isBookable(unitData));

                $unit.find('.fm-discount').toggleClass('d-none', details.isBookable(unitData));
                
                $unit.find('.fm-discount-valid-until').toggleClass('d-none', details.isBookable(unitData));

                $unit.find('.no-period-label').toggleClass('d-none', details.isBookable(unitData));

                $unit.find('.btn-booking').toggleClass('d-none', ! details.isBookable(unitData));

                let error = details.getCalcErrorMessage(this.params.calcErrorMessages, unitData);
                $unit.find('.unit-error-container').toggleClass('d-none', details.isBookable(unitData));
                $unit.find('.unit-error-container').text(error);
                
                $unit.find('.availablility-label').toggleClass('d-none', unitData.message != 'notAvailable');
                $unit.find('.no-period-label').toggleClass('d-none', unitData.message == 'notAvailable' || details.isBookable(unitData));

                $unit.find('.no-calculation').addClass('d-none');
            });
        }
    },
    loader($target = null) {
        $target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);
    }
};
